import * as THREE from "three";

function getWorkspace3DCameraOrientationVectors({ camera }: { camera: THREE.Camera }) {
	const cameraForward = new THREE.Vector3(0, 0, -1).applyQuaternion(camera.quaternion);
	const cameraUp = new THREE.Vector3(0, 1, 0).applyQuaternion(camera.quaternion);

	return { cameraForward, cameraUp };
}

export { getWorkspace3DCameraOrientationVectors };
